import { CircleHelp } from 'lucide-react'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@/components/ui/tooltip'
import { sumWorkload } from '@/domain/review/workload-summary.rules'
import type { DesiredEducationCourse } from '@/types/education/desired-education-course'
import type { PreviousEducation } from '@/types/education/previous-education'
import { formatWorkloadHours } from '@/utils/format-workload-hours'
import { RequestItem } from '../request-item'

const MISSING_IN_TRANSCRIPT = 'Não identificado no histórico'

interface RequestDataWorkloadSummaryProps {
  previousEducation?: PreviousEducation
  curriculumCourses?: DesiredEducationCourse[]
}

const IntegralizedWorkloadHint = () => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="O que é carga horária integralizada"
          className="text-foreground"
        >
          <CircleHelp size={16} />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="bottom"
        className="max-w-72 border border-[var(--brand-blue-1)] bg-background px-3 py-2 text-foreground/70 shadow-md"
      >
        <strong>Carga Horária Integralizada</strong> é o total de horas que o
        aluno <strong>cursou e está como aprovado</strong> no currículo anexado.
      </TooltipContent>
    </Tooltip>
  )
}

export const RequestDataWorkloadSummary = ({
  previousEducation,
  curriculumCourses
}: RequestDataWorkloadSummaryProps) => {
  const previousTotalWorkload = previousEducation?.totalWorkload
  const integralizedWorkload = previousEducation?.integralizedWorkload

  return (
    <>
      <li>
        <RequestItem
          label="Carga Horária do Histórico Anterior"
          value={formatWorkloadHours(
            previousTotalWorkload,
            MISSING_IN_TRANSCRIPT
          )}
          muted={previousTotalWorkload == null}
        />
      </li>
      <li>
        <RequestItem
          label="Carga Horária Integralizada"
          value={formatWorkloadHours(
            integralizedWorkload,
            MISSING_IN_TRANSCRIPT
          )}
          muted={integralizedWorkload == null}
        >
          <IntegralizedWorkloadHint />
        </RequestItem>
      </li>
      <li>
        <RequestItem
          label="Carga Horária do Currículo Desejado"
          value={formatWorkloadHours(sumWorkload(curriculumCourses))}
        />
      </li>
    </>
  )
}
